import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalLeerMenuPermission = ({ isOpen, toggle, selectedMenuPermission }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Permiso de Menú</ModalHeader>
            <ModalBody>
                {selectedMenuPermission ? (
                    <div>
                        <p><strong>Tenant ID:</strong> {selectedMenuPermission.tenant_id}</p>
                        <p><strong>ID de Menú:</strong> {selectedMenuPermission.menu_id}</p>
                        <p><strong>Rol:</strong> {selectedMenuPermission.role}</p>
                    </div>
                ) : (
                    <p>No se ha seleccionado un permiso de menú.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerMenuPermission;